import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export default function useVariantSelectedSku(
  fullVariantsArray,
  choosenVariants,
  product,
  actionToBringSku
) {
  const dispatch = useDispatch();

  // STATE THAT HOLDS CHOOSEN SKU
  const [multiSku, setMultiSku] = useState("");

  // RECEIVE CHOOSEN VARIANTS AND CREATE SKU
  useEffect(() => {
    if (
      fullVariantsArray &&
      fullVariantsArray.length &&
      choosenVariants.length === fullVariantsArray.length &&
      product
    ) {
      // First create an array of objects from choosenVariants and bring the variant code info.
      const variantArr = choosenVariants.map((variant) => {
        return {
          variantCode: variant.split("-")[3],
        };
      });

      // Turn the codes array into a string and remove comma
      const choosenCode = variantArr
        .map((code) => code.variantCode)
        .toString()
        .replaceAll(",", "");

      // Get the skus in stock and crate a string of variant codes
      // Then find the sku that includes the choosen variant code
      const foundSkuCode = product.skus
        .map((sku) => {
          return (
            sku.countInStock > 0 && {
              sku: sku.sku,
              variantCode: `${
                sku.target.split("-")[2] ? sku.target.split("-")[2] : ""
              }${sku.type.split("-")[2] ? sku.type.split("-")[2] : ""}${
                sku.size.split("-")[2] ? sku.size.split("-")[2] : ""
              }${sku.color.split("-")[2] ? sku.color.split("-")[2] : ""}`,
            }
          );
        })
        .filter((sku) => sku !== false)
        .filter((code) => code.variantCode.includes(choosenCode))[0];

      setMultiSku(foundSkuCode ? foundSkuCode.sku : "");

      /* Sending a get request to bring in the sku data to update image galery. 
      I could get it from product.skus too but this request built in early stages and 
      there are other things depend on it so l dont want to touch it for now. */

      if (foundSkuCode) {
        dispatch(actionToBringSku(product._id, foundSkuCode.sku));
      }

      // console.log(product.modelName + "-" + arr.toString().replace(/,/g, ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [choosenVariants, fullVariantsArray, product, dispatch]);

  return multiSku;
}
